import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Redirect } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import { validateUser } from "../../../system/utils/UserPermissions";
import Aux from "../../../system/containers/Aux";
import Loading from "../../../system/components/Loading";
import PageHeader from "../../../system/components/PageHeader";
import FormWrapper from "../../../system/components/FormWrapper";
import FlexWrapper from "../../../system/components/FlexWrapper";
import EditSideColumn from "./components/EditSideColumn";

import { actionCreators } from "../../../store/enquiries/deal";
import Form from "./Form";

class Create extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requiredPermissions: ["CREATE_USERS", "ALL"]
    };
  }

  // Submit function goes here.  Will be the PUT request of the model.
  submit = values => {
    this.props.dispatch(actionCreators.create(values));
  };

  componentWillMount() {
    validateUser(this.props.permissions, this.state.requiredPermissions);
  }

  render() {
    const { loading, success } = this.props;
    if (success) {
      // Redirect when entry created
      return <Redirect to="/test" />;
    }

    if (loading) {
      return <Loading />;
    } else {
      return (
        <Aux>
          <PageHeader title="Create Entry" />
          <FlexWrapper>
            <FormWrapper>
              <Scrollbars>
                <Form onSubmit={this.submit} mode="create" {...this.props} />
              </Scrollbars>
            </FormWrapper>
            <EditSideColumn
              submit={this.submit}
              isLoading={loading}
              mode="create"
            />
          </FlexWrapper>
        </Aux>
      );
    }
  }
}

function mapStateToProps(store) {
  return {
    permissions: store.auth.permissions,
    loading: store.enquiriesDeals.loading,
    success: store.enquiriesDeals.success,
  };
}

export default withRouter(connect(mapStateToProps)(Create));



// WEBPACK FOOTER //
// ./src/containers/Enquiries/DealEnquiry/Create.jsx